import { render, staticRenderFns } from "./ButtonSendEmail.vue?vue&type=template&id=5d4b4c61&scoped=true&"
import script from "./ButtonSendEmail.vue?vue&type=script&lang=ts&"
export * from "./ButtonSendEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSendEmail.vue?vue&type=style&index=0&id=5d4b4c61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b4c61",
  null
  
)

export default component.exports